import { Injectable } from "@angular/core";

import {
  CodehelpService,
  ConfigMapService,
  envMode,
  HttpService,
} from "virtue-form";
import { EncryptDecreptService } from "./encrypt-decrept.service";
import { GlobalVarService } from "./global-var.service";

@Injectable({
  providedIn: "root",
})
export class CommonHandlerService {
  constructor(
    private EncryptDecrpt: EncryptDecreptService,
    public globalvar: GlobalVarService,
    private codehelp: CodehelpService
  ) {}

  setEncrptKeyWithUrl(submissionsUrl: any) {
    var encrypted = this.EncryptDecrpt.set(
      "govirtue@123",
      JSON.stringify(submissionsUrl)
    );
    const encrypted_split = encrypted.split("/");
    const ect_string = encrypted_split.join("***");
    let hostname = "";

    if (
      window.location.hostname == "tech.virtueanalytics.com" ||
      window.location.hostname == "localhost"
    ) {
      hostname = "https://tech.virtueanalytics.com/top5App/home/login/0/";
    } else {
      hostname = "https://" + window.location.hostname + "/top5/home/login/0/";
    }

    return hostname + ect_string;
  }

  setEncrpt(submissionsUrl: any) {
    var encrypted = this.EncryptDecrpt.set(
      "govirtue@123",
      JSON.stringify(submissionsUrl)
    );
    const encrypted_split = encrypted.split("/");
    const ect_string = encrypted_split.join("***");
    
    return ect_string;
  }




  getDecriptKeyWithURL(decrypt_data: any) {
    const encrypted_split = decrypt_data.split("***");
    const decrypt_string = encrypted_split.join("/");
    const browser_decrytData = decodeURIComponent(decrypt_string);
    let decreptURL = JSON.parse(this.EncryptDecrpt.get("govirtue@123", browser_decrytData));
    return decreptURL;
  }

  checkAndSetAPIPoint(Url: string) {
    if (Url == "localhost") {
      return "Local";
    } else if (Url == "tech.virtueanalytics.com") {
      return "Tech";
    } else if (
      Url == "app.virtueanalytics.com" ||
      Url == "top5.virtueanalytics.com" ||
      Url == "find.top5colleges.us" ||
      Url == "app.top5colleges.us"
    ) {
      return "Prod";
    } else {
      return "Other";
    }
  }

  handleUrlrequest(split_Array: string[], LoginType: string, formData: string) {
    //let LoginType =this.handleLoginRequest(split_Array);
    if (LoginType == "DirectLogin") {
      const decrypt_data = split_Array[split_Array.length - 1];
      const browser_decryt = this.getDecriptKeyWithURL(decrypt_data);
      if (browser_decryt != undefined || browser_decryt != "undefined") {
        let decreptURL = JSON.parse(
          this.EncryptDecrpt.get("govirtue@123", browser_decryt)
        );
        if (
          decreptURL?.top5_request != undefined &&
          decreptURL?.top5_request == true
        ) {
          this.globalvar.isTokenLogin = true;
          this.globalvar.top5SubscriptionDashboardRequestData = decreptURL;
          this.codehelp.setStoreValue("top5RequestLogin", "true");
        } else {
          if (
            decreptURL?.username != undefined &&
            decreptURL?.password != undefined
          ) {
            this.globalvar.userLoginDetails = decreptURL;
          }
        }
      }
    } else {
      if (LoginType == "AutofillLogin" && formData) {
        this.globalvar.seFormFilledId = formData;
      }
    }
  }

  handleLoginRequest(split_Array: string[]) {
    let loginType = "";
    // let hostName = "Prod";
    let hostName = this.checkAndSetAPIPoint(document.location.hostname);
    if (hostName == "Local") {
      if (split_Array[4] == "login" && split_Array[5] == "0") {
        loginType = "DirectLogin";
        this.handleUrlrequest(split_Array, loginType, split_Array[4]);
      } else {
        if (
          split_Array[6] != undefined &&
          split_Array[6] != null &&
          split_Array[6] != ""
        ) {
          loginType = "AutofillLogin";
          this.handleUrlrequest(split_Array, loginType, split_Array[6]);
        }
      }
    }
    //  else if (hostName == "Tech") {
    //     if (split_Array[5] == "login" && split_Array[6] == "0") {
    //       loginType = "DirectLogin";
    //       this.handleUrlrequest(split_Array, loginType, split_Array[4]);
    //     } else {
    //       if (
    //         split_Array[7] != undefined &&
    //         split_Array[7] != null &&
    //         split_Array[7] != ""
    //       ) {
    //         loginType = "AutofillLogin";
    //         this.handleUrlrequest(split_Array, loginType, split_Array[6]);
    //       }
    //     }
    //   }
    else if (hostName == "Prod" || hostName == "Tech") {
      if (split_Array[5] == "login" && split_Array[6] == "0") {
        loginType = "DirectLogin";
        this.handleUrlrequest(split_Array, loginType, split_Array[5]);
      }
      if (
        split_Array[7] != undefined &&
        split_Array[7] != null &&
        split_Array[7] != ""
      ) {
        loginType = "AutofillLogin";
        this.handleUrlrequest(split_Array, loginType, split_Array[7]);
      }
    } else {
      loginType = "";
    }

    // return loginType;
  }



  getyearWiseCollegeData(yearWiseCollegeData: any,year:number) {
    let years=0;
    if (
      yearWiseCollegeData &&
      yearWiseCollegeData[year] != undefined
    ) {
      years = year;
    } else {
      if (
        yearWiseCollegeData &&
        yearWiseCollegeData[year - 1] != undefined
      ) {
        years = year - 1;
      }
    }

    return years;
  }





}
